import { useEffect, useRef } from 'react'
import { ApiRetailerPaymentType } from '@vend/types'
import { trackError } from '@vend/utilities'
import { usePaymentManager } from '../../../../ng-compat/hooks'
import { useAppSelector } from '../../../../state/hooks'
import { selectSaleLocalId } from '../../../../state/slices/currentSale/currentSaleSlice'
import { PaymentData } from '../PaymentPanel'

export type RecoveryPaymentOptions = {
  intentId?: string
  transactionId?: string
  recoveryAmount?: string | number
}
export type LSPaymentProps = {
  lspayPaymentType: ApiRetailerPaymentType | undefined
  pay: (paymentType: ApiRetailerPaymentType, paymentData?: PaymentData) => void
}

/**
 * Hook to verify whether there's a need to recover a lspay transaction and initiate the recovery
 * Run once only when lspayPaymentType is set
 */
export const useTransactionRecovery = (props: LSPaymentProps) => {
  const { lspayPaymentType, pay } = props
  const paymentManager = usePaymentManager()
  const saleLocalId = useAppSelector(selectSaleLocalId)
  const ref = useRef(false)

  useEffect(() => {
    if (ref.current || !lspayPaymentType) {
      return
    }

    try {
      const {
        intentId,
        registerSalePaymentId,
        amount: recoveryAmount,
      } = paymentManager.checkAndRetriveActivePayment(saleLocalId)

      if (!registerSalePaymentId) {
        return
      }
      const recoveryPaymentOptions = {
        intentId,
        registerSalePaymentId,
        recoveryAmount,
      }

      pay(lspayPaymentType, { recoveryPaymentOptions })
    } catch (error) {
      trackError('Failed to complete payment recovery for LSPay transaction', {
        error,
      })
    } finally {
      ref.current = true
    }
  }, [paymentManager, lspayPaymentType, saleLocalId, pay])
}
